import { render } from "./SlideEins.vue?vue&type=template&id=650a363e"
import script from "./SlideEins.vue?vue&type=script&lang=js"
export * from "./SlideEins.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bene\\Development\\machina_eX\\LayersOfLife\\bundesanstalt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__